import React, { useEffect, useState } from 'react';
import ReactJson from 'react-json-view';
import { frontApi, API_ROUTES } from '_app/api';
import { Box } from '@chakra-ui/react';

const ExpandedComponent = ({ userName }) => {
  const [data, setData] = useState({});

  const fetchData = React.useCallback(async () => {
    try {
      const { data } = await frontApi(API_ROUTES.user.profile(userName));

      setData(data);
    } catch (error) {
      console.warn(error);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [])

  return (
    <Box p={4}>
      <ReactJson src={data} displayDataTypes={false} />
    </Box>
  )
}

export default ExpandedComponent
